// src/components/CustomerForm.js
import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { toast } from 'react-toastify';
import { API_URL } from './apiurl';

function CustomerForm({ onClose, editingCustomer }) {
  const { auth } = useContext(AuthContext);
  const [vorname, setVorname] = useState('');
  const [nachname, setNachname] = useState('');
  const [strasse, setStrasse] = useState('');
  const [plz, setPlz] = useState('');
  const [ort, setOrt] = useState('');
  const [telefon, setTelefon] = useState('');
  const [email, setEmail] = useState('');

  //const API_URL = '/api';

  useEffect(() => {
    if (editingCustomer) {
      setVorname(editingCustomer.vorname || '');
      setNachname(editingCustomer.nachname || '');
      setStrasse(editingCustomer.strasse || '');
      setPlz(editingCustomer.plz || '');
      setOrt(editingCustomer.ort || '');
      setTelefon(editingCustomer.telefon || '');
      setEmail(editingCustomer.email || '');
    }
  }, [editingCustomer]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!nachname.trim()) {
      toast.error('Nachname ist erforderlich.');
      return;
    }

    const customerData = {
      vorname: vorname.trim(),
      nachname: nachname.trim(),
      strasse: strasse.trim(),
      plz: plz.trim(),
      ort: ort.trim(),
      telefon: telefon.trim(),
      email: email.trim(),
    };

    try {
      let response;
      if (editingCustomer) {
        response = await fetch(`${API_URL}/customers/${editingCustomer.id}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth.token}`,
          },
          body: JSON.stringify(customerData),
        });
      } else {
        response = await fetch(`${API_URL}/customers`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth.token}`,
          },
          body: JSON.stringify(customerData),
        });
      }

      const data = await response.json();

      if (response.ok) {
        toast.success(`Kunde erfolgreich ${editingCustomer ? 'aktualisiert' : 'hinzugefügt'}.`);
        onClose();
      } else {
        throw new Error(data.error || 'Fehler beim Speichern des Kunden.');
      }
    } catch (err) {
      console.error('Fehler beim Speichern des Kunden:', err);
      toast.error(err.message || 'Serverfehler beim Speichern des Kunden.');
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h3>{editingCustomer ? 'Kunden bearbeiten' : 'Neuen Kunden hinzufügen'}</h3>
        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.formGroup}>
            <label>Vorname:</label>
            <input
              type="text"
              value={vorname}
              onChange={(e) => setVorname(e.target.value)}
              style={styles.input}
              placeholder="Vorname"
            />
          </div>
          <div style={styles.formGroup}>
            <label>Nachname*:</label>
            <input
              type="text"
              value={nachname}
              onChange={(e) => setNachname(e.target.value)}
              style={styles.input}
              placeholder="Nachname"
              required
            />
          </div>
          <div style={styles.formGroup}>
            <label>Straße:</label>
            <input
              type="text"
              value={strasse}
              onChange={(e) => setStrasse(e.target.value)}
              style={styles.input}
              placeholder="Straße"
            />
          </div>
          <div style={styles.formGroup}>
            <label>PLZ:</label>
            <input
              type="text"
              value={plz}
              onChange={(e) => setPlz(e.target.value)}
              style={styles.input}
              placeholder="PLZ"
            />
          </div>
          <div style={styles.formGroup}>
            <label>Ort:</label>
            <input
              type="text"
              value={ort}
              onChange={(e) => setOrt(e.target.value)}
              style={styles.input}
              placeholder="Ort"
            />
          </div>
          <div style={styles.formGroup}>
            <label>Telefon:</label>
            <input
              type="text"
              value={telefon}
              onChange={(e) => setTelefon(e.target.value)}
              style={styles.input}
              placeholder="Telefon"
            />
          </div>
          <div style={styles.formGroup}>
            <label>Email:</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={styles.input}
              placeholder="Email"
            />
          </div>
          <div style={styles.buttonGroup}>
            <button type="submit" style={styles.saveButton}>
              {editingCustomer ? 'Aktualisieren' : 'Speichern'}
            </button>
            <button type="button" onClick={onClose} style={styles.cancelButton}>Abbrechen</button>
          </div>
        </form>
      </div>
    </div>
  );
}

// -- Styles --
const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modal: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '2rem',
    width: '500px',
    boxShadow: '0 4px 14px rgba(0,0,0,0.1)',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.3rem',
  },
  input: {
    padding: '0.5rem',
    fontSize: '1rem',
    border: '1px solid #d1d5db',
    borderRadius: '6px',
  },
  buttonGroup: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '1rem',
  },
  saveButton: {
    backgroundColor: '#10b981',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    padding: '0.5rem 1rem',
    cursor: 'pointer',
    fontSize: '1rem',
  },
  cancelButton: {
    backgroundColor: '#6b7280',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    padding: '0.5rem 1rem',
    cursor: 'pointer',
    fontSize: '1rem',
  },
};

export default CustomerForm;
